/**
 * <product-recommendations> (sections/related-products.liquid).
 *
 * The section's own liquid render is empty on a normal page load because
 * `recommendations` isn't populated without product_id/limit/intent query
 * params. This fetches the exact same section via the Section Rendering
 * API with those params (data-url, built server-side) and, if the response
 * actually contains recommendations, swaps this element's content in.
 * No JS -> the row is just absent, same as a merchant who hasn't set up
 * any related products yet.
 */
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      this.refetch();
    }

    /* Split out so product-tabs.js can ask for it again. The tabs ADOPT this
       element's content - physically move it into the recommendations tab -
       so after the theme editor re-renders the tabs section, the adopted
       nodes are destroyed with the old DOM while this host sits here empty,
       its one fetch long since spent. Without a way to fetch again, the
       recommendations tab was simply gone until a full page reload. */
    refetch() {
      const url = this.dataset.url;
      if (!url || this.refetching) return;
      this.refetching = true;

      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const next = doc.querySelector('product-recommendations');
          if (next && next.innerHTML.trim() !== '') {
            this.innerHTML = next.innerHTML;
            /* Fetched markup never sees DOMContentLoaded or
               shopify:section:load, so without this the recommendation
               cards shimmer as "loading" forever. */
            if (window.ThemeReveal) window.ThemeReveal.init(this);
          }
          this.refetching = false;
        })
        .catch(() => {
          // Leave the element empty - no related products row rather than
          // a broken one. refetching stays false so a later ask can retry.
          this.refetching = false;
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
